import * as z from "zod"
import { TrackingShipmentStatus } from "@prisma/client"

export const TrackingShipmentModel = z.object({
  id: z.number().int(),
  created_at: z.date(),
  updated_at: z.date(),
  tracking_number: z.string(),
  /**
   * [TrackingShipmentHandler]
   */
  tracking_handler: z.string().nullish(),
  replaced_by_id: z.number().int().nullish(),
  request_id: z.number().int().nullish(),
  status: z.nativeEnum(TrackingShipmentStatus),
})
